"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = require("./color");
/**
 * Simple class which holds the properties
 * of the color represention model hsla (hue saturation lightness alpha)
 */
function HSVaColor(h, s, v, a) {
    if (h === void 0) { h = 0; }
    if (s === void 0) { s = 0; }
    if (v === void 0) { v = 0; }
    if (a === void 0) { a = 1; }
    var ceil = Math.ceil;
    var that = {
        h: h, s: s, v: v, a: a,
        toHSVA: function () {
            var hsva = [that.h, that.s, that.v];
            var rhsva = hsva.map(ceil);
            hsva.push(that.a);
            hsva.toString = function () { return "hsva(" + rhsva[0] + ", " + rhsva[1] + "%, " + rhsva[2] + "%, " + that.a.toFixed(1) + ")"; };
            return hsva;
        },
        toHSLA: function () {
            var hsla = color_1.hsvToHsl(that.h, that.s, that.v);
            var rhsla = hsla.map(ceil);
            hsla.push(that.a);
            hsla.toString = function () { return "hsla(" + rhsla[0] + ", " + rhsla[1] + "%, " + rhsla[2] + "%, " + that.a.toFixed(1) + ")"; };
            return hsla;
        },
        toRGBA: function () {
            var rgba = color_1.hsvToRgb(that.h, that.s, that.v);
            var rrgba = rgba.map(ceil);
            rgba.push(that.a);
            rgba.toString = function () { return "rgba(" + rrgba[0] + ", " + rrgba[1] + ", " + rrgba[2] + ", " + that.a.toFixed(1) + ")"; };
            return rgba;
        },
        toCMYK: function () {
            var cmyk = color_1.hsvToCmyk(that.h, that.s, that.v);
            var rcmyk = cmyk.map(ceil);
            cmyk.toString = function () { return "cmyk(" + rcmyk[0] + "%, " + rcmyk[1] + "%, " + rcmyk[2] + "%, " + rcmyk[3] + "%)"; };
            return cmyk;
        },
        toHEXA: function () {
            var hex = color_1.hsvToHex(that.h, that.s, that.v);
            hex.toString = function () {
                // Check if alpha channel make sense, convert it to 255 number space, convert
                // to hex and pad it with zeros if needet.
                var alpha = that.a >= 1 ? '' : Number((that.a * 255).toFixed(0))
                    .toString(16)
                    .toUpperCase().padStart(2, '0');
                return "#" + (hex.join('').toUpperCase() + alpha);
            };
            return hex;
        },
        clone: function () {
            return HSVaColor(that.h, that.s, that.v, that.a);
        }
    };
    return that;
}
exports.HSVaColor = HSVaColor;
